import React from 'react';
import './FloatingSidebar.css';
import { TaobaoOutlined } from '@ant-design/icons';

const FloatingSidebar: React.FC = () => {
  const handleJDClick = () => {
    // 跳转到解郁丸京东官方店铺
    window.open('https://jieyu.jd.com/', '_blank');
  };

  const handleTaobaoClick = () => {
    // 跳转到解郁丸天猫官方店铺
    window.open('https://tstfdyf.tmall.com/', '_blank');
  };

  return (
    <div className="floating-sidebar">
      <div className="sidebar-content">
        <div className="sidebar-item jd-item" onClick={handleJDClick}>
          <img src={require('../assets/icon/jd_1.png')} alt="京东" className="sidebar-icon" />
          <span className="sidebar-text">京东店铺</span>
        </div>
        <div className="sidebar-item taobao-item" onClick={handleTaobaoClick}>
          <span className="icon">
            <TaobaoOutlined style={{ fontSize: 32, color: '#DF7638' }} />
          </span>
          <span className="sidebar-text">淘宝店铺</span>
        </div>
      </div>
    </div>
  );
};

export default FloatingSidebar; 